export default __webpack_public_path__ + "static/media/realdealer.fa61a90c.png";